import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@paysera/react-common';
import AgencyApplyForm from './AgencyApplyForm';
import { Spinner } from '../../shared/components';
import { applyToVacancy } from '../../services';
import { errorMessage, getSourceId, getVacancyIdFromUrl } from '../../shared/utils';

const AgencyApply = () => {
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { t } = useTranslation('PayseraRecruitmentBundle');

    const handleSubmit = async ({
        firstName,
        lastName,
        email,
        phone,
        englishLevel,
        country,
        cv,
        linkedIn,
        information,
        submitTask,
        nameOfAgency,
        agencyID,
        agencyEmail,
        contactPerson,
        agencyFeedback
    }) => {
        const {
            content,
            name,
            type,
        } = cv?.[0]?.uploadedFile || {};

        const requestObject = {
            ...(firstName && lastName ? { full_name: `${firstName} ${lastName}` } : {}),
            ...(email ? { email } : {}),
            ...(phone ? { phone_numbers: [phone] } : {}),
            ...(linkedIn ? { urls: [linkedIn] } : {}),
            ...(country ? { location: country } : {}),
            ...(englishLevel ? { english_level: englishLevel } : {}),
            ...(information || agencyFeedback ? { additional_information: `${information} ${agencyFeedback}` } : {}),
            ...(submitTask ? { submit_task: submitTask } : {}),
            ...(content && name && type ? { resume: `data:${type};name=${name};base64,${content}`} : {}),
            ...(nameOfAgency ? { agency_name: nameOfAgency } : {}),
            ...(agencyID ? { agency_id: agencyID } : {}),
            ...(agencyEmail ? { agency_email: agencyEmail } : {}),
            ...(contactPerson ? { agencys_representative: contactPerson } : {}),
            source_id: getSourceId(),
        };

        try {
            setLoading(true);
            const vacancyId = getVacancyIdFromUrl();

            await applyToVacancy(vacancyId, requestObject);

            setShowSuccessAlert(true);
        } catch (errors) {
            setError(t(errorMessage(errors)));
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Spinner />;
    if (error) return <Alert bsStyle="danger">{error}</Alert>;

    return (
        <div>
            {!showSuccessAlert && <AgencyApplyForm onSubmit={handleSubmit} />}
            {showSuccessAlert && (
                <Alert bsStyle="success">{t('common.submit_success')}</Alert>
            )}
        </div>
    );
};

export default AgencyApply;
